// extracted by mini-css-extract-plugin
module.exports = {"headLabel":"e_Hv","title":"e_Iv","subTitle":"e_Jv","promoted":"e_Kv"};